import { ComingSoonBadge } from 'shared/components/badge/coming-soon-badge'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twMerge } from 'tailwind-merge'

interface IntegrationCardProps {
  icon: JSX.Element
  title: string
  subTitle: string
  isConnect?: boolean
  isDeactivated?: boolean
  isComingSoon?: boolean
  onClick?: () => void
}

export const WrapperIntegration = ({
  icon,
  title,
  subTitle,
  onClick,
  isConnect = false,
  isDeactivated = false,
  isComingSoon = false,
}: IntegrationCardProps) => {
  const { t } = useLocoTranslation()

  return (
    <div
      className={twMerge(
        'bg-background-secondary border-background-secondary main-transition-colors flex h-[200px] w-full flex-col justify-between rounded-md border p-5 md:h-[220px] md:w-[320px] lg:p-7',
        onClick && 'hover:bg-brand-primary-subtle hover:border-brand-primary cursor-pointer',
      )}
      onClick={onClick}
    >
      <div className={'mb-2.5 '}>
        <div className={'mb-2.5 flex items-center gap-2.5 lg:mb-5'}>
          {icon}
          <h3>{title}</h3>
        </div>
        <span>{subTitle}</span>
      </div>
      {isComingSoon && (
        <div className={'flex justify-center'}>
          <ComingSoonBadge />
        </div>
      )}
      {isConnect && (
        <div className={'flex justify-center'}>
          <span className={'text-green border-green bg-green/10 rounded-md border px-2.5 py-1.5'}>
            {t('dashboard.user_settings.integrations_page.connected')}
          </span>
        </div>
      )}
      {isDeactivated && (
        <div className={'flex justify-center'}>
          <span
            className={'text-danger border-danger bg-danger/10 rounded-md border px-2.5 py-1.5'}
          >
            {t('dashboard.user_settings.integrations_page.deactivated')}
          </span>
        </div>
      )}
    </div>
  )
}
